import { environment } from 'src/environments/environment';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RunnerService {

  private api = environment.applicationApi;

  runJob() {
    // const job = new Job();
    // return this.http.post(this.api + '/jobs', job);
  }

}
